import api from './api';

export default {
  async getTableData() {
    try {
      const response = await api.get('/users_balance/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  }
};
